import { render, staticRenderFns } from "./AppointmentsDisplay.vue?vue&type=template&id=6e935a38&scoped=true"
import script from "./AppointmentsDisplay.vue?vue&type=script&lang=ts"
export * from "./AppointmentsDisplay.vue?vue&type=script&lang=ts"
import style0 from "./AppointmentsDisplay.vue?vue&type=style&index=0&id=6e935a38&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e935a38",
  null
  
)

export default component.exports